import { Stack, Button } from '@mui/material';
import OrderSummary from '../../storePages/reservation/checkout/components/OrderSummary';
import useCheckoutStore from '../../../../stores/public/useCheckoutStore';
import OrderCreditCardCheckout from '../../orders/OrderCreditCardCheckout';
import { useState } from 'react';
import WushCard from '../../../layout/WushCard';
import useStorefrontStore from '../../../../stores/public/useStorefrontStore';
import destroy from '../../../../api/public/storefronts/reservations/destroy';
import show from '../../../../api/auth/orders/show';
import { useNavigate } from 'react-router-dom';

export default function Summary({ previousStep }) {
  const [checkingOut, setCheckingOut] = useState(false);
  const { organization } = useStorefrontStore();

  const { order, setOrder, reservations, removeReservation } = useCheckoutStore();

  const navigate = useNavigate();

  const handleRemoveReservation = (reservation) => {
    removeReservation(reservation);

    destroy(organization.id, reservation.id);
  };

  const refreshOrder = () => {
    show(order.id, (response) => {
      setOrder(response);
      navigate(`/storefront/${order.organization_id}/order_confirmation`);
    });
  };

  return (
    <Stack>
      <Stack gap={2} mb={2}>
        <Stack>
          <WushCard bgcolor={"#ffffff"}>
            <Stack p={2}>
              <OrderSummary order={order} reservations={reservations} showCheckoutButton={false} handleRemoveReservation={handleRemoveReservation} />
            </Stack>
          </WushCard>
        </Stack>
      </Stack>
      {checkingOut ?
      <Stack mb={2}>
        <WushCard bgcolor={"#ffffff"}>
          <Stack p={2}>
            <OrderCreditCardCheckout
              order={order}
              returnUrl={`https://ims.wush.life/storefront/${order.organization_id}/order_confirmation`}
              afterSuccess={refreshOrder}
            />
          </Stack>
        </WushCard>
      </Stack>
      :
      <Stack width="100%" justifyContent="center" px={"25%"} mb={2}>
        <Button variant="contained" onClick={() => setCheckingOut(true)}>Checkout</Button>
      </Stack>}
      <Stack direction={"row"} width={"100%"} justifyContent={"center"}>
        <Button onClick={previousStep}>Back</Button>
      </Stack>
    </Stack>
  );
}